export default "__VITE_ASSET__CwzEru8H__"